import BaseService from '@/services/BaseService'

class ConfigurationService {

    constructor() {
        this._httpService = new BaseService();
    }

    getConfigurations() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/configuration-management/configurations`,
            method: 'GET'
        }
        console.info('configurations')
        return this._httpService.service(settings)
    }

}

export default ConfigurationService